module.exports = __webpack_public_path__ + "static/media/Westinghouse-Icon.678589d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/Westinghouse-Icon.png
// module id = 551
// module chunks = 0